<template>
  <div>
    <!-- COMPANIES MODAL -->
    <div>
      <v-row>
        <v-card min-width="285px" max-height="80vh" class="overflow-y-auto">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-card-text style="width: 100%;">
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in companies"
                      :key="index"
                    >
                      <v-list-item-title
                        v-if="index == 0"
                        class="text-red"
                      >
                        {{ item.companyName }}
                      </v-list-item-title>
                      <v-list-item-title
                        v-else
                      >
                        <a
                          href="#"
                          :class="getCompanyClass(item)"
                          @click="handleClick(item)"
                        >
                          {{ item.companyName }}
                        </a>
                      </v-list-item-title>
                      <v-divider thickness="2px"></v-divider>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-row>
    </div>
  </div>
</template>

<script>
import UserData from '../repository/UserData';
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";

export default {
  name: "OptionsMenu",
  props: {
    companies: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    valid: false,
    reply: "",
    show: false,
    opened: [],
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
  }),

  computed: {
    user() {
      return this.auth.getLoggedInUser;
    },

    eboardUpdates() {
      return this.auth.getEboardUpdates;
    },
  },
  
  methods: {
    handleClick(company) {
      this.$emit('company_selected', company);
    },

    getCompanyClass(item) {
      if ((UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId) == item.companyId) {
        return 'text-decoration-none text-success';
      } else {
        return 'text-decoration-none';
      }
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #000000;
}

a:hover {
  color: #F44336;
}
</style>